import {Box} from 'platform/foundation';
import {match} from 'ts-pattern';

import {always} from 'ramda';

import {rentalOrderRoutes} from '@dms/routes';

import {composePath, useNavigate} from 'shared/web';

import {RentalResourceCalendarContent} from './components/RentalResourceCalendarContent';
import {RentalResourceCalendarHeader} from './components/RentalResourceCalendarHeader';
import {useRentalOrderCalendarControl} from './hooks/useRentalOrderCalendarControl';
import type {RentalResourceCalendarEvent} from './types/RentalResourceCalendarEvent';
import {getRentalResourceCalendarDataFromGrid} from './utils/getRentalResourceCalendarDataFromGrid';

export function RentalOrderCalendar() {
  const control = useRentalOrderCalendarControl();
  const navigate = useNavigate();

  const onEventClick = (event: RentalResourceCalendarEvent) => {
    const redirectRoute = match(event.state)
      .with('draft', 'canceled', 'closed', always(rentalOrderRoutes.vehicleAndCustomer))
      .with('reserved', always(rentalOrderRoutes.rentVehicle))
      .with('rented', 'returned', always(rentalOrderRoutes.returnVehicle))
      .otherwise(always(rentalOrderRoutes.vehicleAndCustomer));

    navigate(
      composePath(redirectRoute, {
        params: {id: event.id},
        queryParams: {source: 'rental-order-calendar'},
      })
    );
  };

  return (
    <Box position="relative" width="100%" height="100%">
      <Box
        position="sticky"
        top={0}
        left={0}
        right={0}
        paddingTop={[1, 3]}
        paddingBottom={[1, 0]}
        minHeight={[10, 15]}
        zIndex="BIG_CALENDAR_HEADER"
        backgroundColor="palettes.neutral.10.100"
      >
        <RentalResourceCalendarHeader
          data-testid="rentalResourceCalendar"
          currentDate={control.selectedDate}
          onNavigate={control.onNavigate}
        />
      </Box>
      <RentalResourceCalendarContent
        data-testid="rentalResourceCalendar"
        events={getRentalResourceCalendarDataFromGrid(control.rentalOrders)}
        currentDate={control.selectedDate}
        onEventClick={onEventClick}
      />
    </Box>
  );
}
